import { LinkKind } from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';

/**
 *
 * This function generates a link object for a specific vertical's introductory page.
 * It takes a base URL and a vertical key, and returns an object containing the link's
 * href, id, kind, and value.
 *  @param baseURL - The base URL for the application.
 *  @param verticalKey - The key representing the vertical (e.g., 'childCareLinks', 'seniorCareLinks').
 *  @returns An object containing the link's href, id, kind, and value.
 *  @example
 *  const link = getVerticalIntroductoryLink('https://example.com', 'childCareLinks');
 *  // link will be:
 *  // {
 *  //   href: 'https://example.com/child-care',
 *  //   id: 'intro-to-child-care',
 *  //   kind: 'link',
 *  //   value: 'Intro to child care'
 *  // }
 */

export const getVerticalIntroductoryLink = (baseURL: string, verticalKey: string): LinkKind => {
  const verticalMap: Record<string, Record<string, string>> = Object.freeze({
    childCareLinks: {
      linkSegment: 'child-care',
      titleSegment: 'child care',
    },
    seniorCareLinks: {
      linkSegment: 'senior-care',
      titleSegment: 'senior care',
    },
    petCareLinks: {
      linkSegment: 'pet-care',
      titleSegment: 'pet care',
    },
    tutoringLinks: {
      linkSegment: 'tutoring',
      titleSegment: 'tutoring',
    },
    housekeepingLinks: {
      linkSegment: 'housekeeping',
      titleSegment: 'housekeeping',
    },
    adultCareLinks: {
      linkSegment: 'adult-care',
      titleSegment: 'adult care',
    },
  });

  // Default to childCareLinks if the key is not found
  const vertical = verticalMap[verticalKey] ?? verticalMap.childCareLinks;

  return {
    href: `${baseURL}/${vertical.linkSegment}`,
    id: `intro-to-${vertical.linkSegment}`,
    kind: 'link',
    value: `Intro to ${vertical.titleSegment}`,
  };
};
